import { useEffect, useState } from "react";
import api from "@/lib/api";
import { FolderTree, FilePlus2, Folder } from "lucide-react";

const SUBFOLDERS = ["01_ADMINISTRATIF", "02_PLANS", "03_VISUELS", "04_CLIENT", "05_FACTURATION", "06_LIVRABLES"];

export default function Drive() {
  const [folders, setFolders] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = async () => {
    const [d, p] = await Promise.all([api.get("/drive"), api.get("/projects")]);
    setFolders(d.data); setProjects(p.data);
  };
  useEffect(() => { load(); }, []);

  const createFromProject = async (pid) => {
    await api.post(`/drive/from-project/${pid}`);
    load();
  };

  const addFile = async (e) => {
    e.preventDefault();
    const fd = Object.fromEntries(new FormData(e.target).entries());
    await api.post(`/drive/${selected.id}/file`, fd);
    e.target.reset();
    const { data } = await api.get("/drive");
    setFolders(data);
    setSelected(data.find((f) => f.id === selected.id));
  };

  const noFolderProjects = projects.filter((p) => !folders.find((f) => f.project_id === p.id));

  return (
    <div className="space-y-6" data-testid="drive-page">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-gray-500">Documentation projet · Simulation</div>
        <h1 className="font-display text-4xl font-bold tracking-tighter mt-1">Drive</h1>
        <p className="text-sm text-gray-600 mt-1">Arborescence CLIENT - VILLE - PROJET générée automatiquement à partir d'un projet.</p>
      </div>

      {noFolderProjects.length > 0 && (
        <div className="card-flat p-4">
          <div className="text-xs uppercase tracking-widest text-gray-500 font-bold mb-2">Projets sans Drive</div>
          <div className="flex flex-wrap gap-2">
            {noFolderProjects.map((p) => (
              <button key={p.id} data-testid={`drive-create-${p.id}`} onClick={() => createFromProject(p.id)} className="text-xs bg-gray-100 hover:bg-gray-900 hover:text-white px-3 py-1.5 rounded-md font-medium transition flex items-center gap-1.5">
                <FolderTree size={12}/> {p.nom}
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className="card-flat p-4 lg:col-span-1">
          <div className="text-xs uppercase tracking-widest font-bold text-gray-500 mb-2">Arborescences</div>
          <div className="space-y-1">
            {folders.map((f) => (
              <button key={f.id} onClick={() => setSelected(f)} data-testid={`drive-folder-${f.id}`} className={`w-full text-left px-3 py-2 rounded text-sm flex items-center gap-2 ${selected?.id === f.id ? "bg-gray-900 text-white" : "hover:bg-gray-50"}`}>
                <Folder size={14}/> <span className="truncate font-mono text-xs">{f.root_path}</span>
              </button>
            ))}
            {folders.length === 0 && <div className="text-xs text-gray-400 italic py-2">Aucun dossier.</div>}
          </div>
        </div>

        <div className="card-flat p-5 lg:col-span-2">
          {selected ? (
            <>
              <div className="font-display text-2xl font-bold tracking-tight">{selected.root_path}</div>
              <div className="text-xs text-gray-500 mt-1">Convention: AAAA-MM-JJ_TYPE_NOM</div>

              <form onSubmit={addFile} className="mt-5 flex gap-2 flex-wrap" data-testid="drive-add-file-form">
                <select name="subfolder" className="border border-gray-300 rounded px-3 py-2 text-sm">{SUBFOLDERS.map((s) => <option key={s}>{s}</option>)}</select>
                <input name="type" placeholder="TYPE (ex: DEVIS)" required className="border border-gray-300 rounded px-3 py-2 text-sm w-40"/>
                <input name="name" placeholder="Nom du document" required className="border border-gray-300 rounded px-3 py-2 text-sm flex-1 min-w-[150px]"/>
                <button type="submit" data-testid="drive-add-file" className="bg-gray-900 text-white px-3 rounded text-sm font-semibold flex items-center gap-1"><FilePlus2 size={14}/> Ajouter</button>
              </form>

              <div className="mt-6 space-y-4">
                {SUBFOLDERS.map((sub) => {
                  const files = (selected.files || []).filter((f) => f.subfolder === sub);
                  return (
                    <div key={sub}>
                      <div className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-2 flex items-center gap-1.5"><Folder size={12}/> {sub} <span className="text-gray-400">({files.length})</span></div>
                      {files.length === 0 ? <div className="text-xs text-gray-400 italic pl-5">— vide</div> : (
                        <div className="space-y-1 pl-5">
                          {files.map((f) => <div key={f.id} className="text-sm font-mono text-gray-700">{f.name}</div>)}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="text-sm text-gray-400 italic text-center py-12">Sélectionnez un dossier.</div>
          )}
        </div>
      </div>
    </div>
  );
}
